import { render, staticRenderFns } from "./EditDocLabNecrop.vue?vue&type=template&id=9cdcfbec&scoped=true"
import script from "./EditDocLabNecrop.vue?vue&type=script&lang=js"
export * from "./EditDocLabNecrop.vue?vue&type=script&lang=js"
import style0 from "./EditDocLabNecrop.vue?vue&type=style&index=0&id=9cdcfbec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cdcfbec",
  null
  
)

export default component.exports